// extracted by mini-css-extract-plugin
export default {"coloredDotCell":"ColoredDotCell_coloredDotCell__tBxfn","tooltipContent":"ColoredDotCell_tooltipContent__ZJIyg"};